module.exports = __webpack_public_path__ + "img/cases-brand-zedriv-lazyload-51.9bd2f4ee.jpg";